import script from "./helpDoc.vue?vue&type=script&setup=true&lang=js"
export * from "./helpDoc.vue?vue&type=script&setup=true&lang=js"

import "./helpDoc.vue?vue&type=style&index=0&id=b8d7df3a&scoped=true&lang=scss"
import "./helpDoc.vue?vue&type=style&index=1&id=b8d7df3a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8d7df3a"]])

export default __exports__